module.exports = __webpack_public_path__ + "assets/img/1bc116fbbc182b44a56a179da8635dd1.svg";